import { BotaoArcade } from './BotaoArcade';
import { desenharPainel } from './cenario';
import { GAME } from '../config/constants';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { aberturaDoMaterial, entregarAoVisualizador } from '../services/materiais';
import { t } from '../services/textos';

/**
 * RI-MAT-03: abre o PDF de um material no visualizador próprio (paginação e
 * busca), por cima da cena. É o mesmo na biblioteca e no seletor de anexos do
 * Modo Versus. Devolve `{ fechar }`; `aoFechar` roda quando o participante fecha.
 */
export function abrirVisualizadorDeMaterial (cena, material, { profundidade = 100, aoFechar = () => {} } = {}) {
    const camada = cena.add.container(0, 0).setDepth(profundidade);
    const fundo = cena.add.rectangle(GAME.CENTER_X, GAME.CENTER_Y, GAME.LARGURA_TOTAL, GAME.HEIGHT, 0x000000, 0.6)
        .setInteractive();
    const painel = cena.add.graphics();
    desenharPainel(painel, 40, 28, 1200, 744);
    const titulo = cena.add.text(640, 66, material.titulo.replace(/\n/g, ' ').toUpperCase(), ARCADE_TEXT.voltar)
        .setOrigin(0.5);
    camada.add([fundo, painel, titulo]);

    const abertura = aberturaDoMaterial(material);
    let cancelarEntrega = () => {};
    if (abertura) {
        // O PDF abre no visualizador próprio (paginação e busca), não no leitor do
        // navegador: no tablet, iframe com PDF direto não desenha nada.
        const quadro = document.createElement('iframe');
        quadro.className = 'visualizador-arcade';
        quadro.src = abertura.endereco;
        quadro.title = `Material: ${material.titulo.replace(/\n/g, ' ')}`;
        quadro.style.width = '1150px';
        quadro.style.height = '580px';
        const dom = cena.add.dom(640, 384, quadro);
        camada.add(dom);
        if (abertura.entregar) {
            // PDF do servidor: baixado com a sessão do participante e entregue ao visualizador.
            cancelarEntrega = entregarAoVisualizador({
                janela: window,
                destino: () => quadro.contentWindow,
                baixar: () => cena.registry.get('fonte').baixarMaterial(material),
                aoFalhar: (falha) => {
                    console.error('[Materiais] não foi possível baixar o documento.', falha);
                    dom.destroy();
                    camada.add(cena.add.text(640, 384, t('materiais.erro_abrir'), {
                        ...ARCADE_TEXT.aviso, wordWrap: { width: 800 }
                    }).setOrigin(0.5));
                }
            });
        }
    } else {
        camada.add(cena.add.text(640, 384, t('materiais.sem_documento'), {
            ...ARCADE_TEXT.aviso, wordWrap: { width: 800 }
        }).setOrigin(0.5));
    }

    let aberto = true;
    const fechar = () => {
        if (!aberto) return;
        aberto = false;
        cancelarEntrega();
        camada.destroy();
        aoFechar();
    };
    camada.add(new BotaoArcade(cena, 640, 722, {
        rotulo: t('materiais.fechar'), largura: 280,
        cores: { fundo: ARCADE_HEX.TINTA, fio: ARCADE_HEX.TINTA, fioMeio: ARCADE_HEX.BRANCO },
        aoClicar: fechar
    }));
    cena.events.once('shutdown', () => {
        if (!aberto) return;
        aberto = false;
        cancelarEntrega();
        aoFechar();
    });
    return { fechar };
}
